import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useEndpoint } from '@apparatix/composables';
import { User } from '@apparatix/schemas/Owner';
import type { SelectionApiResponse, ActivitiesSelections } from '@apparatix/schemas/Selection';

export const useSelectionsStore = defineStore('selections', () => {
  const activities = ref<ActivitiesSelections>({
    methods: [],
    purposes: [],
    reminderTypes: [],
    types: [],
  });

  const users = ref<User[]>([]);
  const salesScopedUsers = ref<User[]>([]);
  const isLoaded = ref(false);
  const awaitLoad = ref(Promise.withResolvers<void>());

  const { makeRequest } = useEndpoint<SelectionApiResponse>({
    type: 'GET',
    successField: 'data',
    url: '/selections',
    onSuccess: response => {
      activities.value = {
        ...response.data.selections.activities,
      };

      users.value = response.data.users;
      salesScopedUsers.value = response.data.salesScopedUsers;

      isLoaded.value = true;
      awaitLoad.value.resolve();
    },
    onError: () => {
      isLoaded.value = true;
      awaitLoad.value.reject();
    },
    toast: {
      showOnSuccess: false,
    },
  });

  makeRequest();

  return {
    activities,
    awaitLoad,
    isLoaded,
    salesScopedUsers,
    users,
  };
});
